function getApplyAllType({ applyAll, applyAllOuter, applyAllInner }) {

  if (applyAll) {
    return "applyAll";
  }

  if (applyAllOuter) {
    return "applyAllOuter";
  }

  if (applyAllInner) {
    return "applyAllInner";
  }
}

function getCheckApplyAll(type, { applyAll, applyAllOuter, applyAllInner }) {
  switch (type) {
    case "applyAll":
      applyAll = true;
      applyAllInner = false;
      applyAllOuter = false;
      break;
    case "applyAllInner":
      applyAll = false;
      applyAllInner = true;
      applyAllOuter = false;
      break;
    case "applyAllOuter":
      applyAll = false;
      applyAllInner = false;
      applyAllOuter = true;
      break;
    default: break;
  }
  return {
    applyAll,
    applyAllInner,
    applyAllOuter
  }
}

const defaultStackupReducer = {
  data: [],
  materialList: [],
  unit: null,
  loading: true,
  stackupColumnsStatus: false,
  stackupError: null
}

function updateStackupData(designID, stackupObj, action) {
  let _stackupObj = stackupObj ? JSON.parse(JSON.stringify(stackupObj)) : {};
  const prevStackupObj = _stackupObj[designID];

  if (!prevStackupObj) {
    _stackupObj[designID] = {
      ...defaultStackupReducer
    };
  }

  _stackupObj[designID] = {
    ..._stackupObj[designID],
    data: action.data ? action.data : _stackupObj[designID].data,
    materialList: action.materialList ? action.materialList : _stackupObj[designID].materialList,
    stackups: action.stackups ? action.stackups : _stackupObj[designID].stackups,
    zones: action.zones ? action.zones : _stackupObj[designID].zones,
    bends: action.bends ? action.bends : _stackupObj[designID].bends,
    unit: action.unit ? action.unit : _stackupObj[designID].unit,
    loading: false
  };
  return _stackupObj;
}

function updateStackupDataByType(designID, stackupObj, type, data, defaultStackupState) {
  let _stackupObj = stackupObj ? JSON.parse(JSON.stringify(stackupObj)) : {};
  const prevStackupObj = _stackupObj[designID];

  if (!prevStackupObj) {
    const _default = defaultStackupState ? defaultStackupState : defaultStackupReducer
    _stackupObj[designID] = {
      ..._default
    };
  }

  _stackupObj[designID][type] = data;
  return _stackupObj;
}

function updateOldStackupData(designID, stackupObj, action, defaultStackupState) {
  let _stackupObj = stackupObj ? JSON.parse(JSON.stringify(stackupObj)) : {};
  const prevStackupObj = _stackupObj[designID];

  if (!prevStackupObj) {
    _stackupObj[designID] = {
      ...defaultStackupState
    };
  }

  _stackupObj[designID] = {
    ..._stackupObj[designID],
    data: action.data,
    unit: action.unit ? action.unit : _stackupObj[designID].unit,
    loading: false
  };

  return _stackupObj;
}

function removeStackupData(designID, stackupObj) {
  let _stackupObj = stackupObj ? JSON.parse(JSON.stringify(stackupObj)) : {};
  _stackupObj[designID] = undefined;
  return _stackupObj;
}

/**
 * PCB 层叠 XML 解析与逻辑处理模块
 */

// --- XML 解析器 ---
function parseDielectrics(xmlDoc) {
  const nodes = xmlDoc.querySelectorAll('ELayers > Dielectrics > Layer');
  const layers = [];
  nodes.forEach(n => {
    layers.push({
      name: n.getAttribute('Name') || 'Dielectric',
      material: n.getAttribute('Material') || 'N/A',
      thickness: parseFloat(n.getAttribute('Thickness')) || 0,
      color: '#ffffff',
    });
  });
  return layers;
}

function parseConductors(xmlDoc) {
  const nodes = xmlDoc.querySelectorAll('ELayers > Layers > Layer[Type="conductor"]');
  const layers = [];
  nodes.forEach(n => {
    layers.push({
      name: n.getAttribute('Name') || 'Conductor',
      targetLayer: n.getAttribute('TargetLayer'),
      material: n.getAttribute('Material') || 'N/A',
      thickness: parseFloat(n.getAttribute('Thickness')) || 0,
      elevation: parseFloat(n.getAttribute('Elevation')) || 0,
      color: n.getAttribute('Color') || '#7f8c8d'
    });
  });
  return layers;
}

function parseVias(xmlDoc) {
  const nodes = xmlDoc.querySelectorAll('ELayers > Vias > Layer');
  const layers = [];
  nodes.forEach(n => {
    layers.push({
      name: n.getAttribute('Name') || 'Via',
      material: n.getAttribute('Material') || 'N/A',
      startLayer: n.getAttribute('StartLayer'),
      stopLayer: n.getAttribute('StopLayer'),
      color: n.getAttribute('Color') || '#2c3e50'
    });
  });
  return layers;
}

// --- 逻辑处理核心 ---
function processStackup(dielectrics, conductors, vias) {
  let currentHeight = 0;
  let currentDisplayHeight = 0;
  const heightMap = [];

  // 1. 介质层处理：从底向上计算真实坐标 (底部的 substrate Elevation 为 0)
  const revDiel = [].concat(dielectrics).reverse();

  // 缩放算法逻辑 (对数缩放确保薄层可见)
  const logThicknesses = revDiel.map(d => Math.log10(Math.max(d.thickness, 0.001)));
  const minLog = Math.min(...logThicknesses);
  const maxLog = Math.max(...logThicknesses);
  const compression = (maxLog - minLog) > 0 ? Math.log(6) / (maxLog - minLog) : 1;

  const dielPositions = revDiel.map(layer => {
    const displayT = (Math.log10(Math.max(layer.thickness, 0.001)) - minLog) * compression + 1;
    const pos = {
      layer: layer,
      displayBottom: currentDisplayHeight,
      displayTop: currentDisplayHeight + displayT,
      displayHeight: displayT,
      realBottom: currentHeight,
      realTop: currentHeight + layer.thickness,
      topElevation: currentHeight + layer.thickness // 物理顶端高度
    };
    heightMap.push(pos);
    currentHeight += layer.thickness;
    currentDisplayHeight += displayT;
    return pos;
  });

  // 坐标映射函数：将真实物理高度映射到显示像素高度
  const realToDisplay = (realH) => {
    let range = heightMap.find(h => realH >= h.realBottom && realH <= (h.realTop + 0.0001));
    if (!range) return realH > currentHeight ? currentDisplayHeight : 0;
    const ratio = (realH - range.realBottom) / (range.realTop - range.realBottom || 1);
    return range.displayBottom + (ratio * range.displayHeight);
  };

  // 2. 金属层处理
  const metalPositions = conductors.map(layer => ({
    layer: layer,
    displayTop: realToDisplay(layer.elevation + layer.thickness),
    displayBottom: realToDisplay(layer.elevation),
    displayHeight: realToDisplay(layer.elevation + layer.thickness) - realToDisplay(layer.elevation),
    topElevation: layer.elevation + layer.thickness // 物理顶端高度
  }));

  // 3. 过孔处理
  const processedVias = [];
  vias.forEach(v => {
    const startM = metalPositions.find(m => m.layer.name === v.startLayer || m.layer.targetLayer === v.startLayer);
    const stopM = metalPositions.find(m => m.layer.name === v.stopLayer || m.layer.targetLayer === v.stopLayer);

    if (startM && stopM) {
      const isStartHigher = startM.layer.elevation > stopM.layer.elevation;
      const upper = isStartHigher ? startM : stopM;
      const lower = isStartHigher ? stopM : startM;

      processedVias.push({
        via: v,
        displayTop: upper.displayBottom, // 过孔顶端接上层金属底部
        displayBottom: lower.displayTop,  // 过孔底端接下层金属顶部
        displayHeight: Math.abs(upper.displayBottom - lower.displayTop),
        realElevation: lower.layer.elevation + lower.layer.thickness,
        realThickness: Math.abs(upper.layer.elevation - (lower.layer.elevation + lower.layer.thickness)),
        topElevation: upper.layer.elevation // 以连接的上层金属底部作为物理排序基准
      });
    }
  });

  // 4. 表格数据整合与严格物理排序
  let allTableLayers = [];

  metalPositions.forEach(m => {
    allTableLayers.push({
      ...m.layer,
      type: 'Conductor',
      topElevation: m.topElevation,
      info: m.layer.targetLayer || '-'
    });
  });

  dielPositions.forEach(dp => {
    allTableLayers.push({
      name: dp.layer.name,
      type: 'Dielectric',
      thickness: dp.layer.thickness,
      elevation: dp.realBottom,
      topElevation: dp.topElevation,
      material: dp.layer.material,
      info: '-'
    });
  });

  processedVias.forEach(pv => {
    allTableLayers.push({
      name: pv.via.name,
      type: 'Via',
      thickness: pv.realThickness.toFixed(2),
      elevation: pv.realElevation.toFixed(2),
      topElevation: pv.topElevation,
      material: pv.via.material,
      info: `${pv.via.startLayer} ↔ ${pv.via.stopLayer}`
    });
  });

  // --- 物理层级核心排序算法 ---
  allTableLayers.sort((a, b) => {
    // 1. 获取顶端高度 (Elevation + Thickness)
    const aTop = (parseFloat(a.elevation) || 0) + (parseFloat(a.thickness) || 0);
    const bTop = (parseFloat(b.elevation) || 0) + (parseFloat(b.thickness) || 0);

    // 2. 比较顶端高度 (降序：从 Top 到 Bottom)
    // 使用 0.001 的阈值处理浮点数精度问题
    if (Math.abs(bTop - aTop) > 0.001) {
      return bTop - aTop;
    }

    // 3. 如果顶端高度完全相同：
    // 定义物理优先级：Conductor > Via > Dielectric
    // 这样在同一水平高度起始时，金属层会排在介质层前面
    const typeWeights = { 'Conductor': 10, 'Via': 50, 'Dielectric': 30 };
    const weightA = typeWeights[a.type] || 0;
    const weightB = typeWeights[b.type] || 0;

    if (weightA !== weightB) {
      return weightB - weightA; // 权重高的排在前面
    }

    // 4. 如果顶端高度和类型都相同，比较底端高度 (Elevation) 
    // 较厚的层排在后面
    return b.elevation - a.elevation;
  });

  // 5. 过孔避让分组 (用于 Canvas/SVG 绘制)
  const viaGroups = [];
  [...processedVias].sort((a, b) => b.displayTop - a.displayTop).forEach(v => {
    let placed = false;
    for (let g = 0; g < viaGroups.length; g++) {
      let overlap = viaGroups[g].some(e => !(v.displayBottom >= e.displayTop || v.displayTop <= e.displayBottom));
      if (!overlap) {
        viaGroups[g].push(v);
        placed = true;
        break;
      }
    }
    if (!placed) viaGroups.push([v]);
  });

  return {
    dielectrics: dielPositions.reverse(),
    metals: metalPositions.sort((a, b) => b.topElevation - a.topElevation),
    viaGroups: viaGroups,
    allTableLayers: allTableLayers,
    totalDisplayHeight: currentDisplayHeight
  };
}

/**
 * 主入口函数
 */
export function processStackupXmlData(xml) {
  try {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xml, 'text/xml');

    let data = processStackup(
      parseDielectrics(xmlDoc),
      parseConductors(xmlDoc),
      parseVias(xmlDoc)
    );

    // 为表格添加显示索引
    data.allTableLayers = data.allTableLayers.map((layer, index) => ({
      ...layer,
      indexStackup: index + 1
    }));

    return data;
  } catch (error) {
    console.error("Stackup XML Parsing Error:", error);
    return null;
  }
}

export {
  getApplyAllType,
  getCheckApplyAll,
  updateStackupData,
  updateStackupDataByType,
  defaultStackupReducer,
  updateOldStackupData,
  removeStackupData
}